import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Input } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputTextInterface } from "../../../interfaces/Global.interface";
// UTILS
import {
	validateIpAString,
	validateIpAndPortString,
	validateDoubleIpAndPortString,
	validateDoubleHostAndPortString,
} from "../../../utils/utils";

export default function FormularyHeaderInputText({
	columnName,
	inputPlaceholder,
	formAction,
	value,
	onChangeFormValue,
	variableName,
	itemId,
	onClickCellName = () => {},
	enabledCellClick = false,
	enabledFilter = false,
	filterValue = "",
	setFilterValue = () => {},
	refreshTable = () => {},
	inputValidationType = "na",
	textLink = false,
}: FormularyHeaderInputTextInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Column, ColumnGroup } = Table;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const getInputStatus = (textValue: string) => {
		if (inputValidationType === "ip") {
			if (!validateIpAString(textValue) && textValue !== "") {
				return "error";
			}
		} else if (inputValidationType === "ipAndPort") {
			if (!validateIpAndPortString(textValue) && textValue !== "") {
				return "error";
			}
		} else if (inputValidationType === "doubleIpAndPort") {
			if (!validateDoubleIpAndPortString(textValue) && textValue !== "") {
				return "error";
			}
		} else if (inputValidationType === "stringIpAndPort") {
			if (!validateDoubleHostAndPortString(textValue) && textValue !== "") {
				return "error";
			}
		}
		return "";
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<ColumnGroup title={columnName}>
			<Column
				className='generalStyles__hoverCursor'
				onCell={(record: any) => ({
					onClick: () => {
						if (enabledCellClick && formAction === "create") {
							onClickCellName(record);
						}
					},
				})}
				filterDropdown={() => (
					<>
						{enabledFilter && (
							<FilterSearchText
								placeHolder={inputPlaceholder}
								filterValue={filterValue}
								setFilterValue={setFilterValue}
								refreshTable={refreshTable}
								refreshRequireParamenters
							/>
						)}
					</>
				)}
				filterIcon={enabledFilter ? undefined : () => null}
				title={
					<Input
						addonBefore={
							columnName.toLocaleLowerCase() === "name" ? (
								<FontAwesomeIcon icon={faPlus} className='generalStyles__info' />
							) : null
						}
						size='small'
						placeholder={inputPlaceholder}
						value={formAction === "create" ? value : ""}
						disabled={formAction === "edit"}
						onChange={(event) => onChangeFormValue(event.currentTarget.value, variableName)}
						status={getInputStatus(value)}
					/>
				}
				dataIndex={variableName}
				key={variableName}
				render={(text, record: any) => (
					<div>
						{formAction === "edit" && record.id === itemId ? (
							<Input
								addonBefore={
									columnName.toLocaleLowerCase() === "name" ? (
										<FontAwesomeIcon icon={faPen} className='generalStyles__info' />
									) : null
								}
								size='small'
								placeholder={inputPlaceholder}
								value={value}
								onChange={(event: React.FormEvent<HTMLInputElement>) => {
									onChangeFormValue(event.currentTarget.value, variableName);
								}}
								status={getInputStatus(text)}
							/>
						) : (
							<div className={textLink ? "generalStyles__info" : ""}>{text}</div>
						)}
					</div>
				)}
			/>
		</ColumnGroup>
	);
}
